export default __webpack_public_path__ + "static/media/logo_b.2970a925.svg";